/* eslint-disable */
import { FormControlLabel, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { compose } from 'redux';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import SelectionsPropTypes from './Selections.component.props';
import selectionsStyles from './Selections.component.styles';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

/**
 * SelectionsComponent
 * @export
 * @class SelectionsComponent
 * @extends {React.Component<SelectionsComponentComposedProps, SelectionsComponentState>}
 */
export class SelectionsComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<SelectionsComponentProps>}
   * @memberof SelectionsComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`Selections`}
   * @memberof SelectionsComponent
   */
  static displayName = `Selections`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof SelectionsComponent
   */
  static propTypes = SelectionsPropTypes;

  /**
   * Data specific to the `<SelectionsComponent />` instance
   * @type {SelectionsComponentState}
   * @memberof SelectionsComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<SelectionsComponent />`
   * @memberof SelectionsComponent
   */
  render() {
    const { classes, onClickSearchButton, items, onToggle } = this.props;
    if (isEmpty(items)) {
      return (
        <Grid container>
          <Button onClick={onClickSearchButton} size="small">
            <I18n variant="caption">OrderService.AddressSearch.Labels.Search</I18n>
          </Button>
        </Grid>
      );
    }
    return (
      <List dense>
        {Object.entries(items)
          .map(([label, isSelected]) => (
            <FormControlLabel
              control={<Checkbox checked={isSelected} color="default" disableRipple onChange={onToggle(label, !isSelected)} tabIndex={-1} />}
              label={
                <React.Fragment>
                  <Typography classes={{ root: classes.addressListItem }} data-mf-replace-inner={MFSDR}>{`${label.substring(0, 22)}...`}</Typography>
                </React.Fragment>
              }
            />
          ))
          .reverse()}
      </List>
    );
  }
}

/** @type {React.ComponentClass<SelectionsComponentProps>} */
const Selections = compose(withStyles(themeCreateInjectableStyles(selectionsStyles), { withTheme: true }))(SelectionsComponent);

export default Selections;
